/* eslint no-param-reassign: "off", no-console: "off" */
import { orderBy } from 'lodash';

const searchStore = {
  state: {
    autoSearching: false,
    remoteAutoResults: [],
    remoteResults: [],
    deviceAutoResults: [],
    deviceResults: [],
    subscriptionAutoResults: [],
    subscriptionResults: [],
    terminalAutoResults: [],
    terminalResults: [],
    docAutoResults: [],
    docResults: [],
    recentResults: [],
    searchHistory: []
  },
  mutations: {
    addAutoResults(state, payload) {
      state.remoteAutoResults = payload.remoteResults || [];
      state.deviceAutoResults = payload.deviceResults || [];
      state.subscriptionAutoResults = payload.subscriptionResults || [];
      state.docAutoResults = payload.documentResults || [];
      state.terminalAutoResults = payload.terminalResults || [];
      state.autoSearching = false;
    },
    clearAllAutoResults(state) {
      state.remoteAutoResults = [];
      state.deviceAutoResults = [];
      state.subscriptionAutoResults = [];
      state.docAutoResults = [];
      state.terminalAutoResults = [];
    },
    fetchRecentResults(state, payload) {
      state.recentResults = payload || [];
    },
    fetchSearchHistory(state, payload) {
      state.searchHistory = payload || [];
    },
    clearSearchCache(state) {
      state.recentResults = [];
      state.searchHistory = [];
    }
  },
  actions: {
    async runAutoSearch({ state, commit }, payload) {
      // payload.term contains the search query
      try {
        state.autoSearching = true;
        const searchResult = await fetch(`/v2/search?searchTerm=${payload.term}&take=10`);
        const results = await searchResult.json()
        commit('addAutoResults', results);
      } catch (ex) {
        console.error(ex);
      }
    },
    async fetchRecentResults({ commit }) {
      // eslint-disable-next-line no-undef
      let s = await $userStore.getItem('recentResults');
      if (!s) s = [];
      commit('fetchRecentResults', s);
      return s;
    },
    async addRecentResult({ commit, dispatch }, payload) {
      let currentRecents = await dispatch('fetchRecentResults');
      // if we have 5 or more results, we need to trim
      if (currentRecents.length >= 5) {
        // order by timestamp descending, so oldest is on top
        currentRecents = orderBy(currentRecents, ['ts'], ['desc']);
        // remove oldest
        currentRecents.pop();
      }
      // add timestamp
      payload.ts = Date.now();
      // add new result
      currentRecents.unshift(payload);
      // save to datastore
      // eslint-disable-next-line no-undef
      await $userStore.setItem('recentResults', currentRecents);
      commit('fetchRecentResults', currentRecents);
    },
    async fetchSearchHistory({ commit }) {
      // eslint-disable-next-line no-undef
      let s = await $userStore.getItem('searchHistory');
      if (!s) s = [];
      commit('fetchSearchHistory', s);
      return s;
    },
    async addSearchHistory({ commit, dispatch }, payload) {
      // fetch current history first
      let currentHistory = await dispatch('fetchSearchHistory');
      // if an item with the same term already exists in history, remove it and add this new one
      const existingTerm = currentHistory?.find(h => h.term === payload.term);
      if (existingTerm) currentHistory = currentHistory.filter(h => h.term !== payload.term);

      // if we have 5 or more results, we need to trim
      if (currentHistory.length >= 5) {
        // order by timestamp descending, so oldest is on top
        currentHistory = orderBy(currentHistory, ['ts'], ['desc']);
        // remove oldest
        currentHistory.pop();
      }
      // set current timestamp
      payload.ts = Date.now();
      // add new result
      currentHistory.unshift(payload);
      // save to datastore
      // eslint-disable-next-line no-undef
      await $userStore.setItem('searchHistory', currentHistory);
      commit('fetchSearchHistory', currentHistory);
    },
    async clearSearchCache({ commit }) {
      // eslint-disable-next-line no-undef
      await $userStore.removeItem('searchHistory');
      // eslint-disable-next-line no-undef
      await $userStore.removeItem('recentResults');
      commit('clearSearchCache');
    }
  },
  getters: {
    
  }
}

export default searchStore;
